import { create } from 'zustand';
import { ReactNode } from 'react';

export interface ActionButton {
  id: string;
  label: string;
  icon?: ReactNode;
  onClick?: () => void;
  href?: string;
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  disabled?: boolean;
}

interface PageHeaderState {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  badge?: ReactNode;
  isEditable?: boolean;
  onTitleChange?: (newTitle: string) => void;
  actions?: ActionButton[];
  setHeader: (
    title: string, 
    subtitle?: string, 
    icon?: ReactNode, 
    badge?: ReactNode,
    options?: {
      isEditable?: boolean;
      onTitleChange?: (newTitle: string) => void;
      actions?: ActionButton[];
    }
  ) => void;
  setActions: (actions: ActionButton[]) => void;
  clearHeader: () => void;
}

export const usePageHeaderStore = create<PageHeaderState>((set) => ({
  title: '',
  subtitle: undefined,
  icon: undefined,
  badge: undefined,
  isEditable: false,
  onTitleChange: undefined,
  actions: [],
  setHeader: (title, subtitle, icon, badge, options) => set({ 
    title, 
    subtitle, 
    icon, 
    badge,
    isEditable: options?.isEditable ?? false,
    onTitleChange: options?.onTitleChange,
    actions: options?.actions ?? [],
  }),
  setActions: (actions) => set({ actions }),
  clearHeader: () => set({ 
    title: '', 
    subtitle: undefined, 
    icon: undefined, 
    badge: undefined,
    isEditable: false,
    onTitleChange: undefined,
    actions: [],
  }),
}));

